import { render } from "./pca-form-check-box.vue?vue&type=template&id=423e8060"
import script from "./pca-form-check-box.vue?vue&type=script&setup=true&lang=js"
export * from "./pca-form-check-box.vue?vue&type=script&setup=true&lang=js"

import "./pca-form-check-box.vue?vue&type=style&index=0&id=423e8060&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/print-contract/components/pca-form-check-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "423e8060"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('423e8060', __exports__)) {
    api.reload('423e8060', __exports__)
  }
  
  module.hot.accept("./pca-form-check-box.vue?vue&type=template&id=423e8060", () => {
    api.rerender('423e8060', render)
  })

}


export default __exports__